// ---------------------------------------------------------------------------
// SyntheticJobPreviewPage — Standalone route that hosts a single synthetic
// run's preview. All logic lives in `SyntheticRunPreview`; this page just
// wires URL → component and provides the data-hub client context required
// by the Save flow.
// ---------------------------------------------------------------------------

import { Body1, Title2 } from '@fluentui/react-components';
import { useParams } from 'react-router';

import { SyntheticRunPreview } from '../../components/SyntheticGen/SyntheticRunPreview/SyntheticRunPreview.js';
import { DataHubClientProvider } from '../../context/DataHubClientContext.js';

import { useStyles } from './SyntheticJobPreviewPage.style.js';

export function SyntheticJobPreviewPage() {
  const styles = useStyles();
  const { jobId } = useParams<{ jobId: string }>();

  if (jobId === undefined) {
    return (
      <div className={styles.root}>
        <Title2>Synthetic generation</Title2>
        <Body1 className={styles.errorBanner}>Missing job id in URL.</Body1>
      </div>
    );
  }

  return (
    <DataHubClientProvider>
      <div className={styles.root}>
        <div className={styles.header}>
          <Title2>Synthetic generation</Title2>
          <span className={styles.jobIdMono}>Job {jobId}</span>
        </div>
        <SyntheticRunPreview jobId={jobId} />
      </div>
    </DataHubClientProvider>
  );
}
